import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const tyreDropdown = async () => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/tyre`,
        );

        return response.data.map((item) => ({
            key: item.tyrId,
            text: item.tyrSize,
            value: item.tyrId,
        }));
    } catch (e) {
        console.error(e);
    }
};
